import EntityImageActions from '../../entityImage/EntityImageActions';

const EquipmentImageActions = () => <EntityImageActions entityType="equipment" />;

export default EquipmentImageActions;
